<!-- 新帮助中心 -->
<template>
  <div class="newHelpDetailBox">
    <Nav />
    <div class="newHelpDetail">
      <!-- banner -->
      <div class="banner">
        <h1 class="wow animate__animated animate__rollIn ">步峰代理帮助中心</h1>
        <div class="_search">
          <el-input
            placeholder="请输入问题关键字"
            v-model="searchInput"
            class="input-with-select"
            @keyup.enter.native="jumpSearch"
          >
            <el-button @click.stop="jumpSearch" type="success" slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>
      </div>
      <div class="_center">
        <template v-if="loading">
          <div
            class="center-content"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 255, 255, 1)"
          />
        </template>
        <template v-else>
          <div class="_search_empty" v-if="searchList.length == 0">
            <img class="_img" src="../assets/no_search.png" alt="">
            <p class="_p1">暂无搜索结果</p>
            <p class="_p2">您可以尝试换一换关键词或者联系客服</p>
            <p class="_p3" @click.stop="lxkf()">联系客服</p>
          </div>
          <div class="_search_result" v-else>
            <div class="_top">共找到<span class="_number">{{searchList.length}}</span>条结果</div>
            <div class="_list" v-for="item in searchList" :key="item.id">
              <div class="title">{{ item.name }}</div>
              <div class="_li" v-for="(j, k) in item.articles" :key="k" @click.stop="jumpDetail(j.id)">
                <div class="_title" v-html="returnKey(j.title)"></div>
                <p class="_note">{{j.description}}</p>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import { WOW } from 'wowjs' 
import Foot from '@/components/Foot.vue'
import { request } from "../css/request.js";
import { Apis } from "../css/Api.js";
export default {
  name: 'newHelpSearch',
  components: {
    Nav,
    Foot
  },
  data(){
    return {
      searchInput:'',
      searchList:[],
      searchKey:'',
      loading: true
    }
  },
  created(){
    if(this.$route.query.search){
      this.searchInput = this.$route.query.search
      setTimeout(() => {
        this.getSearch()
      }, 3000);
    }
  },
  methods:{
    lxkf(){
      this.$store.commit("setfloatingType", true);
    },
    /*
      str.replace(/world/g, "test");
    */
   returnKey(key){
     let _g = eval(`/${this.searchInput}/g`)
     return key.replace(_g, `<span style="color: #FF7A46;">${this.searchInput}</span>`);
   },
   getSearch(){
    this.loading = true
    request({
				method: "get", 
				url: Apis.readArticleTitleList,
        params:{
          title: this.searchInput
        },
        _type:1,
			}).then(res => {
				if(res.code == 0){
          this.searchList = res.data
				}else{
					this.$message.error(res.msg);
				}
			}).finally(() => {
        this.loading = false
      })
   },
    jumpSearch(){
      if (this.searchInput === '' || !this.searchInput){
        this.$message({
					message: '请输入问题关键字',
					showClose: true,
					duration:1500,
          type: 'warning'
				});
      } else {
        this.getSearch()
      }
    },
    jumpDetail(id){
      this.$router.push({ 
				path: `/newhelpdetail`,
				query: {
					id: id
				}
			})
    }
  }

}
</script>

<style lang="less" scoped>
.newHelpDetailBox{
  width: 100%;
  .newHelpDetail{
    width: 100%;
    background: #f9f9f9;
    .banner{
			width: 100%;
			height: 284px;
			background: url('../assets/newHelpBg.png')no-repeat;
			background-size: 100% 100%;
			h1,h3{
				width: 100%;
				color: #fff;
				text-align: center;  
				text-shadow: -2px 2px 0px #616161;
			}
			h1{
				font-size: 43px;
				font-weight: bold;
				padding-top: 68px;
			}
      ._search{
        width: 472px;
        height: 35px;
        margin: 0 auto;
        margin-top: 23px;
      }
      ._hot{
        width: 420px;
        height: 30px;
        margin: 0 auto;
        margin-top: 15px;
        display: flex;
        justify-content: left;
        ._hot_sear{
          font-size: 14px;
          color: #fff;
          position: relative;
          line-height: 30px;
        }
        ._hot_sear::before{
          display: inline-block;
          content: '';
          width: 15px;
          height: 18px;
          background: url('../assets/hot.png')no-repeat;
          background-size: 100%;
          position: absolute;
          left: -20px;
          top: 4px;
        }
        ._hot_issue{
          padding:8px 17px ;
          border-radius: 100px;
          background: rgba(255, 255, 255, 0.2);
          line-height: 15px;
          color: #fff;
          font-size: 14px;
          margin-left: 21px;
        }
      }
    }
    ._center{
      width: 1200px;
      margin: 0 auto;
      .center-content{
        width: 850px;
        min-height: 300px;
        margin: 0 auto;
      }
      ._search_empty{
        display: flex;
        flex-direction: column;
        align-items: center;
        ._img{
          width: 193px;
          height: 141px;
          margin-top: 100px;
        }
        ._p1{
          color: #2D2D2C;
          font-size: 18px;
          font-weight: bold;
          margin-top: 35px;
        }
        ._p2{
          color: #2D2D2C;
          font-size: 13px;
          margin-top: 25px;
        }
        ._p3{
          margin-top: 43px;
          padding: 15px 56px;
          border-radius: 100px;
          color: #fff;
          background: #1F8EFF;
          margin-bottom: 82px;
          cursor: pointer; 
        }
      }
      ._search_result{
        width: 850px;
        margin: 0 auto;
        min-height: 300px;
        background: #fff;
        margin-top: 20px;
        padding: 10px 20px;
        ._top{
          width: 100%;
          text-align: left;
          padding-bottom: 10px;
          border-bottom: 1px solid #C9C9C9;
          font-size: 14px;
          ._number{
            color: #FF7A46;
          }
        }
        ._list{
          width: 100%;
          ._li{
            text-align: left;
            padding-left: 20px;
            cursor: pointer; 
            ._note{
              color: #2D2D2C;
              font-size: 12px;
              margin-top: 6px;
              line-height: 20px;
            }
            ._title{
              font-size: 18px;
              font-weight: bold;
              color: #2D2D2C;
              position: relative;
              
            }
            ._key{
                color: #FF7A46;
              }
            ._title::before{
              display: inline-block;
              content: '';
              width: 5px;
              height:5px;
              background: #1F8EFF;
              position: absolute;
              left: -15px;
              top: 50%;
              transform: translateY(-50%);
            }
          }
          ._li:hover{
            ._title{
              color: #1F8EFF;
            }
          }
        }
      }
    }
  }
}
::v-deep .el-icon-loading{
  font-size: 20px;
}
.title{
  font-size: 18px;
  font-weight: bold;
  color: #1E1D1D;
  text-align: left;
  position: relative;
  left:10px;
  padding:15px 0;
  // margin-top: 10px;
}
.title::before{
  display: inline-block;
  content: '';
  width: 4px;
  height: 18px;
  background: #1F8EFF;
  position: absolute;
  top: 19px;
  left: -10px;
}
</style>